// Dependecies
import { createStore, createHook } from 'react-sweet-state';

const initialState = {
  company: '',
  totalService: 0,
  totalServiceFinalized: 0,
  last_service: '',
  totalTypesServices: [],
  vehicleInformation: [],
};
const actions = {
  setDataCompany:
    (token, license, locale) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'POST',
            body: JSON.stringify({
              plate: license,
            }),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };
          const response = await fetch(
            `/api/bread/jwt/services/static/services_dashboard?lang=${locale}`,
            options
          );
          const services = await response.json();
          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ company: services.company });
            setState({ totalService: services.totalService });
            setState({ totalServiceFinalized: services.totalServiceFinalized });
            setState({ totalTypesServices: services.totalTypesServices });
            if (services.last_service) {
              setState({ last_service: services.last_service.date_service });
            } else {
              setState({ last_service: services.last_service });
            }

            resolve(getState());
          }
        } catch (e) {
          reject(e);
        }
      }),
  setDataInformationVehicle:
    (token, plate) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const jsons = {
            licensePlate: plate,
          };
          const options = {
            method: 'POST',
            body: JSON.stringify(jsons),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };
          const response = await fetch('/api/bread/jwt/vehicles/static/project_dashboard', options);
          const newData = await response.json();
          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ vehicleInformation: newData.projectionByVehicle });

            resolve(getState());
          }
        } catch (e) {
          reject(e);
        }
      }),
};

const Store = createStore({
  initialState,
  actions,
  name: 'dashboardCompany',
});

export default createHook(Store);
